import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

const WEBVIEW_FLAG_KEY = 'isWebview';
const memoryStore: { isWebview?: boolean } = {};

function getSessionItem(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return key === WEBVIEW_FLAG_KEY && memoryStore.isWebview ? 'true' : null;
  }
}

function setSessionItem(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    if (key === WEBVIEW_FLAG_KEY) memoryStore.isWebview = value === 'true';
  }
}

@Injectable({
    providedIn: 'root'
})
export class WebviewService {
    private _isWebview = false;

    constructor(private router: Router, private route: ActivatedRoute) {
        // Check initial URL string or window location
        this.checkWebviewState(window.location.search);

        // Also listen to router events to catch query params on navigation
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            // Traverse to the deepest route to get query parameters
            let currentRoute = this.route.root;
            while (currentRoute.children[0] !== undefined) {
                currentRoute = currentRoute.children[0];
            }

            const fromFlutter = currentRoute.snapshot.queryParamMap.get('fromFlutter');
            if (fromFlutter === 'true') {
                this._isWebview = true;
                memoryStore.isWebview = true;
                setSessionItem(WEBVIEW_FLAG_KEY, 'true');
            }
        });

        // Check session storage (or memory) in case of page reloads during webview navigation without the param
        if (getSessionItem(WEBVIEW_FLAG_KEY) === 'true') {
            this._isWebview = true;
            memoryStore.isWebview = true;
        }
    }

    private checkWebviewState(searchParams: string) {
        const params = new URLSearchParams(searchParams);
        if (params.get('fromFlutter') === 'true') {
            this._isWebview = true;
            memoryStore.isWebview = true;
            setSessionItem(WEBVIEW_FLAG_KEY, 'true');
        }
    }

    get isWebview(): boolean {
        return this._isWebview;
    }
}
